export const salersretrunsdata = [
	{
		"id":1,
		"img":"assets/img/products/product1.jpg",
		"productname":"Macbook pro",
		"date": "19 Nov 2022",
		"customer": "Thomas",
		"status": "Received",
		"grandtotal": "550",
		"paid": "120",
		"due": "550",
		"paymentstatus":"Paid",
		
	},
	{
		"id":2,
		"img":"assets/img/products/product2.jpg",
		"productname":"Orange",
		"date": "19 Nov 2022",
		"customer": "Benjamin",
		"status": "Pending",
		"grandtotal": "550",
		"paid": "120",
		"due": "550",
		"paymentstatus":"Unpaid",
		
	},
	{
		"id":3,
		"img":"assets/img/products/product3.jpg",
		"productname":"Pineapple",
		"date": "19 Nov 2022",
		"customer": "James",
		"status": "Pending",
		"grandtotal": "210",
		"paid": "120",
		"due": "210",
		"paymentstatus":"Unpaid",
		
	},
	{
		"id":4,
		"img":"assets/img/products/product4.jpg",
		"productname":"Strawberry",
		"date": "19 Nov 2022",
		"customer": "Bruklin",
		"status": "Received",
		"grandtotal": "210",
		"paid": "120",
		"due": "210",
		"paymentstatus":"Paid",
		
	},
	{
		"id":5,
		"img":"assets/img/products/product5.jpg",
		"productname":"Macbook Pro",
		"date": "19 Nov 2022",
		"customer": "Best Power Tools",
		"status": "Received",
		"grandtotal": "210",
		"paid": "120",
		"due": "210",
		"paymentstatus":"Paid",
		
	},
	{
		"id":6,
		"img":"assets/img/products/product5.jpg",
		"productname":"Avocat",
		"date": "19 Nov 2022",
		"customer": "Beverly",
		"status": "Pending",
		"grandtotal": "210",
		"paid": "120",
		"due": "210",
		"paymentstatus":"Unpaid",
		
	},
	{
		"id":7,
		"img":"assets/img/products/product6.jpg",
		"productname":"Apple Earpods",
		"date": "19 Nov 2022",
		"customer": "Apex Computers",
		"status": "Ordered",
		"grandtotal": "1000",
		"paid": "500",
		"due": "1000",
		"paymentstatus":"Partial",
		
	}
]